module.exports = __webpack_public_path__ + "static/media/general_motors_logo.6e87ffce.png";